import React, {useEffect, useState} from "react";
import cloneDeep from 'lodash/cloneDeep';
import StandIcon from "../../assets/icons/stand-white.svg";
import SpotGroupIcon from "../../assets/icons/spot-group-white.svg";
import useProfileBoostService from "../../api/services/useProfileBoostService";
import useSpotGroupService from "../../api/services/useSpotGroupService";
import {Route, useNavigate} from "react-router-dom";
import useStandService from "../../api/services/useStandService";
import SelectBookable from "../../components/Form/SelectBookable";
import PayWithCredits from "../../components/PayWithCredits/PayWithCredits";
import {Fields, Form} from "../../components/Form/Form";
import useFunction from "../../hooks/useFunction";
import useWizard from "../../hooks/useWizard";
import Loading from "../../components/Loading/Loading";
import useForm from "../../hooks/useForm";
import Wizard from "../../layouts/Wizard/Wizard";
import Button from "../../components/Button/Button";
import Tile from "../../components/Tile/Tile";
import BoostIcon from "../../assets/icons/profile-boost.svg"
import BoostIconWhite from "../../assets/icons/profile-boost-white.svg"
import spotGroupIconWhite from "../../assets/icons/spot-group-white.svg";
import standIconWhite from "../../assets/icons/stand-white.svg";
import useBookable from "../../hooks/useBookable";

const WizardProfileBoost = () => {

  const pathname = "/wizard/boost"
  const form = useForm();
  const navigate = useNavigate()
  const {dateTime} = useFunction()
  const steps = [
    {
      slug: 'start',
      label: 'Start',
      hidden: true,
    },
    {
      slug: 'select_type',
      label: 'Selecteer profiel type',
    },
    {slug: 'select_stand', label: 'Selecteer stand/truck/act'},
    {slug: 'select_spot_group', label: 'Selecteer locatie'},
    {slug: 'create_payment', label: 'Betaling'},
    {slug: 'check_payment', label: 'Betaling'},
    {slug: 'finish', label: 'Finish'}
  ]

  const initialButtonPrev = {
    start: {
      onClick: () => {
        navigate('/user/profile-boosts')
      },
      className: 'btn-color-red',
      label: 'Terug',
    },
    select_type: {
      onClick: () => {
        navigate('/user/profile-boosts')
      },
      className: 'btn-color-red',
      label: 'Annuleren',
    },
    select_spot_group: {
      disabled: false,
      onClick: () => navigate('/user/profile-boosts'),
      className: 'btn-color-red',
      label: 'Annuleren',
    },
    select_stand: {
      disabled: false,
      onClick: () => navigate('/user/profile-boosts'),
      className: 'btn-color-red',
      label: 'Annuleren',
    },

    create_payment: {
      disabled: true,
      visible: false,
    },
    check_payment: {
      disabled: true,
      visible: false,
    },
    finish: {
      disabled: true,
      visible: false,
    }
  }

  const initialButtonNext = {
    start: {
      disabled: true,
      visible: false
    },
    select_type: {
      disabled: true,
      visible: false
    },
    create_payment: {
      disabled: true,
      visible: false,
    },
    check_payment: {
      disabled: true,
      visible: false,
    },
    finish: {
      label: 'Overzicht',
      icons: BoostIconWhite, //todo implement icons
      onClick: () => navigate('/user/profile-boosts')
    }
  };

  const {getBookableStatus} = useBookable()
  const [spotGroups, setSpotGroups] = useState(null)
  const [stands, setStands] = useState(null)
  const profileBoostService = useProfileBoostService()
  const spotGroupService = useSpotGroupService()
  const standService = useStandService()

  /**
   * Hide a step
   * //todo defined on multiple places.. refactor / centralize
   *
   * @param steps
   * @param slug
   */
  const hideStep = (steps, slug) => {
    const index = steps.findIndex(step => step.slug === slug)
    if (index !== -1) {
      steps[index].hidden = true
    }
    return steps
  }

  /**
   * Show a step
   *
   * //todo defined on multiple places.. refactor / centralize
   *
   * @param steps
   * @param slug
   */
  const showStep = (steps, slug) => {
    const index = steps.findIndex(step => step.slug === slug)
    if (index !== -1) {
      steps[index].hidden = false
    }
    return steps
  }

  const updateSteps = (steps, model) => {
    if (model.is_paid) {
      steps = hideStep(steps, 'select_type')
      steps = hideStep(steps, 'select_stand')
      steps = hideStep(steps, 'select_spot_group')
      steps = hideStep(steps, 'create_payment')
      steps = hideStep(steps, 'check_payment')
    }

    // If stand is selected, hide spot_group selection (and vice versa)
    if (model.stand_id) {
      steps = hideStep(steps, 'select_spot_group')
    }
    if (model.spot_group_id) {
      steps = hideStep(steps, 'select_stand')
    }

    return steps
  }

  const updateSuccessNextStep = (profileBoost) => {
    wizard.nextStep(profileBoost.id, profileBoost);
  };

  const wizard = useWizard(
    steps,
    updateSteps,
    pathname,
    initialButtonPrev,
    initialButtonNext,
    form
  )

  useEffect(() => {

    if (wizard.step === 'start') {
      form.setLoading(true)
      if (wizard.id) {
        form.setLoading(true)
        profileBoostService.userShow(
          (profileBoost) => {
            form.setOriginalFormDataModel(cloneDeep(profileBoost))
            form.setFormData(prevFormData => {
                return {
                  ...prevFormData,
                  model: profileBoost,
                  isLoading: false,
                }
              }
            )
            form.setLoading(false)
            wizard.nextStep(profileBoost.id, updateSteps(steps, profileBoost))
          },
          () => {
            form.setLoading(false)
            //todo error handling
          },
          wizard.id,
        )
      } else {

        //do the actual storage of the profileBoost concept
        profileBoostService.userStore(
          (profileBoost) => {
            //back to beginning, but with id
            form.setLoading(false)
            navigate(pathname + '/start/' + profileBoost.id)
          },
          () => {
            form.setLoading(false)
            //todo error handling
          },
        )
      }
    }

    if (wizard.step === 'select_spot_group') {
      if (spotGroups === null) {
        form.setLoading(true)
        spotGroupService.userShowCollection(
          (data) => {
            setSpotGroups(data)
            form.setLoading(false)
          },
          () => {
            //todo error handling
            form.setLoading(false)
          }
        )
      } else {
        wizard.nextButtonDisabled()
      }
    }

    if (wizard.step === 'select_stand') {
      if (stands === null) {
        form.setLoading(true)
        standService.userShowCollection(
          (data) => {
            setStands(data)
            form.setLoading(false)
          },
          () => {
            //todo error handling
            form.setLoading(false)
          },
        )
      } else {
        wizard.nextButtonDisabled()
      }
    }

    if (wizard.step === 'check_payment' && wizard.id) {
      wizard.setFinished(true)
      navigate(pathname + '/finish/' + wizard.id)
    }

  }, [wizard.step, wizard.id, stands, spotGroups])

  return (
    <div className="wizard-profile-boost">
      <Wizard
        form={form}
        wizard={wizard}
      >
        <Route path="/start/*" element={
          <div className="center">
            <Loading/>
          </div>
        }/>

        <Route path="/select_type/*" element={
          <div className="center">
            <div className="width-600">
              <h1>Profiel omhoog plaatsen</h1>
              <p>Door je profiel omhoog te plaatsen, wordt het 1 week lang hoger in de zoekresultaten op de homepagina
                getoond.</p>
              <br/>
              <br/>
              <div className="row">
                <Button
                  label="Voor stand/truck/act"
                  link={pathname + '/select_stand/' + wizard.id}
                  icon={StandIcon}
                />
                <Button
                  label="Voor locatie"
                  link={pathname + '/select_spot_group/' + wizard.id}
                  icon={SpotGroupIcon}
                />
              </div>
            </div>
          </div>
        }/>

        <Route path="/select_stand/*" element={
          <div className="center">
            <div className="width-medium">
              <h1>Selecteer stand/truck/act profiel</h1>
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={profileBoostService}
                  updateSuccess={updateSuccessNextStep}
                  onChange={() => wizard.nextButtonDisabled()}
                  // onChange={() => {}}
                  onReset={() => wizard.setInitialButtons()}
                >
                  {stands !== null ?
                    <div>
                      {stands.length > 0
                        ?
                        <SelectBookable
                          name="stand_id"
                          bookableName="stand"
                          bookables={stands}
                          formData={form.formData}
                          save={form.save}
                          className="form-component-"
                        />
                        :
                        <div>
                          <br/>
                          <br/>
                          <br/>
                          <p>Je hebt nog geen stands aangemaakt/gekoppeld aan je account.</p>
                          <Button
                            label="Toevoegen"
                            link="/wizard/stand/new"
                            icon={standIconWhite}
                          />
                        </div>
                      }
                    </div>
                    : <Loading/>
                  }
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/select_spot_group/*" element={
          <div className="center">
            <div className="width-medium">
              <h1>Selecteer locatie/event profiel</h1>
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={profileBoostService}
                  updateSuccess={updateSuccessNextStep}
                  // onChange={() => {}}
                  onChange={() => wizard.nextButtonDisabled()}
                  onReset={() => wizard.setInitialButtons()}
                >
                  {spotGroups !== null ?
                    <div>
                      {spotGroups.length > 0
                        ?
                        <SelectBookable
                          name="spot_group_id"
                          bookableName="spot_group"
                          bookables={spotGroups}
                          formData={form.formData}
                          save={form.save}
                          className="form-component-"
                        />
                        :
                        <div>
                          <br/>
                          <br/>
                          <br/>
                          <p>Je hebt nog geen locaties aangemaakt/gekoppeld aan je account.</p>
                          <Button
                            label="Toevoegen"
                            link="/wizard/locatie/new"
                            icon={spotGroupIconWhite}
                          />
                        </div>
                      }
                    </div>
                    : <Loading/>
                  }
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/create_payment/*" element={
          <div className="center">
            <div className="width-medium">
              <h1>Betalen met credits?</h1>
              <p>Kosten: €10,- excl. btw voor 1 week omhoogplaatsen.</p>
              <p>Of betaal met Stand credits: totale kosten 1000 Stand credits.Je kunt ook deels met Stand credits
                betalen en het resterende bedrag met euro’s.</p>
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={profileBoostService}
                >
                  <PayWithCredits
                    form={form}
                    amount={10}
                    profileBoostId={wizard.id}
                  />
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/check_payment/*" element={
          <div className="center">
            <div className="width-medium">
              <h1>Betalen</h1>
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={profileBoostService}
                >
                  <Loading/>
                </Fields>
              </Form>
            </div>
          </div>
        }/>

        <Route path="/finish/*" element={
          <div className="center">
            <div className="width-medium">
              <h1>Finish</h1>
              <Form>
                <Fields
                  id={wizard.id}
                  form={form}
                  wizard={wizard}
                  apiService={profileBoostService}
                >
                  {form.formData.model.is_paid
                    ?
                    <div className="step-finished-success">
                      <img src={BoostIcon} alt="" width={60}/>
                      <h3>Dank voor je boost!</h3>
                      <div className="row date">Begin op: {dateTime(form.formData.model.start_at)}</div>
                      <div className="row date">Eind op: {dateTime(form.formData.model.end_at)}</div>

                      {(
                          (!!form.formData.model.stand && getBookableStatus(form.formData.model.stand).key !== 'bookable')
                          ||
                          (!!form.formData.model.spot_group && getBookableStatus(form.formData.model.spot_group).key !== 'bookable')
                        ) &&
                        <span className="color-red">Let op! profiel niet boekbaar. Pas je instellingen aan, anders heeft deze profiel boost geen effect.</span>
                      }

                      {form.formData.model.stand_id &&
                        <Tile bookable={form.formData.model.stand} showEditButton={true}/>
                      }
                      {form.formData.model.spot_group_id &&
                        <Tile bookable={form.formData.model.spot_group} showEditButton={true}/>
                      }
                    </div>
                    :
                    <div>
                      <div className="row">
                        <p>Er is iets fout gegaan met de betaling! neem contact op.</p>
                      </div>
                      <div className="row">
                        <Button
                          label="Start chat"
                          link="/user/berichten/1"
                        />
                      </div>
                    </div>
                  }
                </Fields>
              </Form>
            </div>
          </div>
        }/>

      </Wizard>
    </div>
  )
}

export default WizardProfileBoost